import { map } from 'lodash';
import React from 'react';
import TableHead from '../../../../ReusableComponents/Table/TableHead';
import HeaderRow from '../../../../ReusableComponents/Table/HeaderRow';
import HeaderCell from '../../../../ReusableComponents/Table/HeaderCell';
import TableBody from '../../../../ReusableComponents/Table/TableBody';
import Table from '../../../../ReusableComponents/Table/Table';
import BookingRow from './BookingTableRow';
import { Booking } from '../../../../../Lib/Hooks/types/booking';

const headers = ['Time', 'Date', 'Warehouse', 'Vendor Name', 'Purchase Orders'];

interface Props {
  bookings: Booking[];
}
function BookingTable({ bookings }: Props) {
  return (
    <Table className="w-full">
      <TableHead>
        <HeaderRow>
          {map(headers, (header) => (
            <HeaderCell key={header}>{header}</HeaderCell>
          ))}
        </HeaderRow>
      </TableHead>
      <TableBody>
        {map(bookings, (booking: Booking) => (
          <BookingRow key={booking.id} booking={booking} />
        ))}
      </TableBody>
    </Table>
  );
}

export default BookingTable;
